const IBAN_ACCOUNT_TYPE = "iban";
const ACCOUNT_NUMBER_TYPE = "account_number";

const ibanRegex = /^[A-Za-z]{2}\d{2}[A-Za-z0-9]+$/;
const accountNumberRegex = /^[A-Za-z0-9]+$/;

export const bankAccountTypeOptions = [
  { label: "IBAN", value: IBAN_ACCOUNT_TYPE },
  { label: "Account Number", value: ACCOUNT_NUMBER_TYPE },
];

export const inferBankAccountType = (value) => {
  if (typeof value !== "string") return ACCOUNT_NUMBER_TYPE;

  const normalizedValue = value.trim();
  if (normalizedValue.length >= 15 && normalizedValue.length <= 34 && ibanRegex.test(normalizedValue)) {
    return IBAN_ACCOUNT_TYPE;
  }

  return ACCOUNT_NUMBER_TYPE;
};

export const getBranchRules = (isRequired, message) => (
  isRequired ? [{ required: true, message }] : []
);

export const getBankAccountNumberRules = (accountType) => {
  if (accountType === IBAN_ACCOUNT_TYPE) {
    return [
      { required: true, message: "IBAN is required" },
      {
        validator: (_, value) => {
          const normalizedValue = typeof value === "string" ? value.trim() : "";

          if (!normalizedValue) {
            return Promise.resolve();
          }

          if (normalizedValue.length < 15 || normalizedValue.length > 34) {
            return Promise.reject(new Error("IBAN must be 15 to 34 characters long"));
          }

          if (!ibanRegex.test(normalizedValue)) {
            return Promise.reject(new Error("IBAN must start with 2 letters, then 2 digits, followed by letters or numbers"));
          }

          return Promise.resolve();
        },
      },
    ];
  }

  return [
    { required: true, message: "Account number is required" },
    {
      validator: (_, value) => {
        const normalizedValue = typeof value === "string" ? value.trim() : "";

        if (!normalizedValue) {
          return Promise.resolve();
        }

        if (normalizedValue.length < 6) {
          return Promise.reject(new Error("Account number must be at least 6 characters long"));
        }

        if (!accountNumberRegex.test(normalizedValue)) {
          return Promise.reject(new Error("Account number must contain only letters and numbers"));
        }

        return Promise.resolve();
      },
    },
  ];
};

export { ACCOUNT_NUMBER_TYPE, IBAN_ACCOUNT_TYPE };
